(() => {
  'use strict';
  if (!document.documentElement.lang.toLowerCase().startsWith('en')) return;
  if (globalThis.AsteriaGatesEnCleanBound) return;
  globalThis.AsteriaGatesEnCleanBound = true;

  const map = Object.freeze({
    'Jade / Yeşim / Ceyt':'Jade','Jade / Yeşim':'Jade','Dumanlı Kuvars':'Smoky Quartz','İmparator Jasper':'Imperial Jasper',
    'Turuncu Akik':'Orange Agate','Kırmızı Jasper':'Red Jasper','Pembe Kuvars':'Rose Quartz','Yeşil Akik':'Green Agate',
    'Mavi Akik':'Blue Agate','Mavi Kuvars':'Blue Quartz','Pembe Akik':'Pink Agate','Sarı Akik':'Yellow Agate',
    'Beyaz Akik':'White Agate','Mor Akik':'Purple Agate','Kaplan Gözü':"Tiger's Eye",'Necef Taşı':'Rock Crystal',
    'Lav Taşı':'Lava Stone','Lapis Lazuli':'Lapis Lazuli','Akuamarin':'Aquamarine','Kalsedon':'Chalcedony',
    'Aventurin':'Aventurine','Hematit':'Hematite','Kehribar':'Amber','Larvikit':'Larvikite','Malahit':'Malachite',
    'Mercan':'Coral','Oniks':'Onyx','Sedef':'Mother of Pearl','Sodalit':'Sodalite','Turkuaz':'Turquoise','Ametist':'Amethyst',
    'Apatit':'Apatite','Havlit':'Howlite','İnci':'Pearl','Kuvars':'Quartz','Necef':'Rock Crystal','Akik':'Agate',
    'Cesaret':'Courage','Canlılık ve Motivasyon':'Vitality & Motivation','Canlılık':'Vitality','Özgüven':'Confidence',
    'Dönüşüm ve Yeni Başlangıç':'Transformation & New Beginnings','Dönüşüm':'Transformation','Zarafet ve İçsel Değer':'Elegance & Inner Worth',
    'Uyum ve İlişki':'Harmony & Relationships','Topraklanma':'Grounding','İletişim':'Communication','Berraklık':'Clarity',
    'Öğrenme':'Learning','Sevgi':'Love','Uyum':'Harmony','Sezgi':'Intuition','Büyüme':'Growth','Bilgelik':'Wisdom',
    'Fırsat':'Opportunity','Disiplin':'Discipline','Sınırlar':'Boundaries','Sakinlik':'Calm','Anlam':'Meaning','İçsel Bağ':'Inner Connection',
    'İrade':'Will','Hareket':'Action','Akış':'Flow','Yaratıcılık':'Creativity','Haz':'Enjoyment','Açıklık':'Openness',
    'İfade':'Expression','Doğruluk':'Truth','İçgörü':'Insight','Bütünlük':'Wholeness','Dayanıklılık':'Resilience',
    'Yapı':'Structure','Sebat':'Persistence','Esneklik':'Flexibility','Duruma Uyum':'Contextual Adaptability','Kararlılık':'Determination','Denge':'Balance'
  });

  const entries = Object.entries(map).sort((a,b) => b[0].length - a[0].length);
  const gateSelector = '[data-ae-numerology],[data-ae-yildizname],[data-ae-mizac],[data-ae-zodiac],[data-ae-chakra],[data-ae-birth-chart],[data-ae-marifetname]';
  const isWord = ch => Boolean(ch) && /[\p{L}\p{N}]/u.test(ch);

  function replaceStandalone(text, from, to) {
    let out = '', start = 0, index;
    while ((index = text.indexOf(from, start)) !== -1) {
      const before = index > 0 ? text[index - 1] : '';
      const afterIndex = index + from.length;
      const after = afterIndex < text.length ? text[afterIndex] : '';
      if (!isWord(before) && !isWord(after)) {
        out += text.slice(start, index) + to;
        start = afterIndex;
      } else {
        out += text.slice(start, afterIndex);
        start = afterIndex;
      }
    }
    return out + text.slice(start);
  }

  function translate(value) {
    let text = String(value || '');
    for (const [from,to] of entries) text = replaceStandalone(text, from, to);
    return text;
  }

  function clean(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    for (const node of textNodes) {
      const next = translate(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
    root.querySelectorAll('[alt],[aria-label],[title]').forEach(el => {
      for (const attr of ['alt','aria-label','title']) {
        if (!el.hasAttribute(attr)) continue;
        const value = el.getAttribute(attr);
        const next = translate(value);
        if (next !== value) el.setAttribute(attr,next);
      }
    });
  }

  let queued = false;
  function sync() {
    queued = false;
    document.querySelectorAll(gateSelector).forEach(clean);
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }

  document.addEventListener('DOMContentLoaded', sync, {once:true});
  new MutationObserver(schedule).observe(document.documentElement, {subtree:true, childList:true, characterData:true});
})();
